import React from 'react';
import ReactDOM from 'react-dom';
import CopyModalsLayout from './components/CopyModalsLayout';
import $ from 'jquery';

function renderCopyModals(caseId, isAAST, targetId) {
  const container = document.getElementById('copy-modal-container');

  ReactDOM.render(
    <CopyModalsLayout caseId={caseId} isAAST={isAAST} targetId={targetId} />,
    container
  );

  $('.copy.estimate.button').on('click', evt => {
    evt.preventDefault();
    $('#estimate-copy-modal').modal('show');
  });

  $('.copy.invoice.button').on('click', evt => {
    evt.preventDefault();
    $('#invoice-copy-modal').modal('show');
  });
}

export default function render() {
  const modalContainer = $('#copy-modal-container');

  const siteCase = modalContainer.data('case');
  const isAAST = modalContainer.data('isaast');

  if (siteCase) {
    renderCopyModals(siteCase, isAAST, modalContainer.data('id'));
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/imports/index.js